import { RouteObject  } from 'react-router-dom'
import Report from '../../pages/customReport/commonReport'
import ReportMobile from '../../pages/customReport/mobile/ReportMobile'
import ReportDetailMobile from '../../pages/customReport/mobile/TableDetail'
import React from 'react'
import { TestFilterPage } from './TestFIlterPage'
// import { Test } from '@/hooks/useStateCache/test/testPage'



export const routeReport:RouteObject[] = [
  {
    path: "/customReport/:reportName",
    element: <Report/>
  },
  {
    path: "/mobile/customReport/:reportName",
    element: <ReportMobile/>,
    children: [
      {
        path: "/mobile/customReport/:reportName/reportDetail",
        element: <ReportDetailMobile/>
      },
    ]
  },
  {
    path: "/customReportTestFilterPage/:reportName",
    element: <TestFilterPage></TestFilterPage>
  }
]